"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useCallback } from "react";
import GroupCreateWalletsCount from "./GroupCreateWalletsCount";
import type { GroupCreateWalletsType } from "./GroupCreateWallets";
export default function CreateGroupWalletsUpload(t0) {
  const $ = _c(22);
  const {
    type,
    wallets,
    setWallets
  } = t0;
  const inputRef = useRef(null);
  const getAddresses = _temp3;
  let t1;
  if ($[0] !== setWallets) {
    t1 = file => {
      const reader = new FileReader();
      reader.onload = e => {
        const content = e.target?.result;
        const lines_0 = (content as string).split(/\r?\n/);
        setWallets(getAddresses(lines_0));
      };
      reader.readAsText(file);
    };
    $[0] = setWallets;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onFileChange = t1;
  let t2;
  if ($[2] !== onFileChange) {
    t2 = e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      if (e_0.dataTransfer.files && e_0.dataTransfer.files.length > 0) {
        const file_0 = e_0.dataTransfer.files[0];
        onFileChange(file_0);
      }
    };
    $[2] = onFileChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleDrop = t2;
  const handleDragOver = _temp4;
  const handleDragEnter = _temp5;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="tw-mb-0 tw-text-base sm:tw-text-lg tw-font-semibold tw-text-iron-50">Add wallets manually</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-5 lg:tw-p-6"><div className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-950 tw-border tw-border-solid tw-border-iron-700 tw-transition tw-duration-300 tw-ease-out"><div className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-50"><svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-300" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div></div><p className="tw-mt-4 tw-mb-0 tw-text-sm tw-text-center tw-text-balance tw-text-iron-500">Drag and drop your CSV file here, or click to select a file</p></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `wallets-upload-${type}`;
  let t6;
  if ($[6] !== onFileChange) {
    t6 = e_3 => {
      if (e_3.target.files) {
        const file_1 = e_3.target.files[0];
        onFileChange(file_1);
      }
    };
    $[6] = onFileChange;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <input id={t5} ref={inputRef} type="file" className="tw-hidden" accept="text/csv" onChange={t6} />;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== handleDrop || $[12] !== t7) {
    t8 = <label className={"tw-group tw-mt-2 sm:tw-mt-3\n        tw-bg-iron-900 tw-border-iron-650 tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-h-32 tw-border-2 tw-border-dashed tw-rounded-lg tw-cursor-pointer hover:tw-border-iron-600 hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out"} onDrop={handleDrop} onDragOver={handleDragOver} onDragEnter={handleDragEnter}>{t4}{t7}</label>;
    $[11] = handleDrop;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = wallets?.length ?? null;
  let t10;
  if ($[14] !== setWallets) {
    t10 = () => setWallets(null);
    $[14] = setWallets;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <div className="tw-mt-4 tw-gap-y-2 tw-w-full tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-justify-between"><GroupCreateWalletsCount walletsCount={t9} loading={false} removeWallets={t10} /></div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t8) {
    t12 = <div><div className="tw-p-3 sm:tw-p-5 tw-bg-iron-950 tw-rounded-xl tw-shadow tw-border tw-border-solid tw-border-iron-800">{t3}{t8}{t11}</div></div>;
    $[19] = t11;
    $[20] = t8;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}
function _temp5(e_2) {
  e_2.preventDefault();
  e_2.stopPropagation();
}
function _temp4(e_1) {
  e_1.preventDefault();
  e_1.stopPropagation();
}
function _temp3(lines) {
  const delimiterRegex = /[\s,;]+/;
  const addresses = lines.flatMap(line => line.split(delimiterRegex).map(_temp));
  const filteredAddresses = addresses.filter(_temp2);
  const uniqueAddresses = new Set(filteredAddresses);
  return Array.from(uniqueAddresses) as string[];
}
function _temp2(address_0) {
  return address_0 !== null;
}
function _temp(part) {
  const address = part.trim();
  if (address.match(/^0x[a-fA-F0-9]{40}$/)) {
    return address.toLowerCase();
  }
  return null;
}